import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/dashboard')({
  component: DashboardRoute,
});

function DashboardRoute() {
  const { orgId } = Route.useParams();
  return <DashboardPage orgId={orgId} />;
}
